import { PrinterConnection } from '@yonarezi/yonarezi3.epos-printer'

class PrinterConnectionPool {
  constructor() {
    this.connections = new Map() // ip → { connection, printer }
  }

  async getConnection(ipAddress) {
    const entry = this.connections.get(ipAddress)

    if (entry?.printer?.ePosDev?.isConnected()) {
      return entry.printer
    }

    // 古い接続が残っていれば削除（既に切断済みのためdisconnect()は呼ばない）
    // ePosDev.disconnect()は切断済みの接続に対して呼ぶとSDK内部状態を壊す可能性があるため、
    // GCに任せる
    if (entry) {
      this.connections.delete(ipAddress)
    }

    const connection = new PrinterConnection({ ipAddress })
    const printer = await connection.connect()

    this.connections.set(ipAddress, { connection, printer })

    return printer
  }

  disconnect(ipAddress) {
    const entry = this.connections.get(ipAddress)
    if (entry) {
      entry.connection.disconnect()
      this.connections.delete(ipAddress)
    }
  }

  disconnectAll() {
    Array.from(this.connections.keys()).forEach(ip => {
      this.disconnect(ip)
    })
  }
}

export const printerConnectionPool = new PrinterConnectionPool()
